import Resource from '@/api/Resource';
import Category from '@/models/Category';

export default class Document extends Resource {
  $name = 'documents';

  $defaults() {
    return {
      id: null,
      active: 1,
      category_id: 0,
      name: '',
      description: '',
      file: '',
      file_original_name: '',
      allow_download: 0,
      content: '',
      type: 'file',
      start_date: null,
      end_date: null,
    };
  }

  $fill({ category }) {
    if (category) {
      this.category = new Category(category);
    }
  }

  get isTypeFile() {
    return this.type == 'file';
  }

  get isTypeText() {
    return this.type == 'text';
  }

  get isTypeSlides() {
    return this.type == 'slides';
  }

  get typeName() {
    return {
      file: 'Файл',
      text: 'Текст',
      slides: 'Слайды',
    }[this.type];
  }

  // $fill({ presentations, category }) {
  //   if (presentations) {
  //     this.presentations = Presentation.collection(presentations);
  //   }

  //   if (category) {
  //     this.category = new Category(category);
  //     this.category_id = this.category.id;
  //   }
  // }
}
